(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/numbergames-related/app.js') >= 0) return;  svs.modules.push('/modules/numbergames-related/app.js');

'use strict';

const {
  RelatedPage
} = svs.numbergames_related.pages;
const App = () => React.createElement(React.StrictMode, null, React.createElement(RelatedPage, null));
const target = document.getElementById('numbergames-related-region');
target && ReactDOM.render(React.createElement(App, null), target);

 })(window);